import PhoneNumberCard from "./PhoneNumberCard"
import PhoneType, { PhoneNumber } from "../../../../api/PhoneType"

interface PhoneNumbersProps {
  phones: Record<PhoneType, PhoneNumber>
  readonly: boolean
  onChange: (value: string, type: PhoneType) => void
}

function PhoneNumbers(props: PhoneNumbersProps) {
  const { phones, readonly, onChange } = props

  return (
    <>
      <PhoneNumberCard
        variant={PhoneType.Home}
        phone={phones[PhoneType.Home]}
        readonly={readonly}
        onChange={onChange}
      />
      <PhoneNumberCard
        variant={PhoneType.Work}
        phone={phones[PhoneType.Work]}
        readonly={readonly}
        onChange={onChange}
      />
      <PhoneNumberCard
        variant={PhoneType.Cell}
        phone={phones[PhoneType.Cell]}
        readonly={readonly}
        onChange={onChange}
      />
    </>
  )
}

export default PhoneNumbers
